import React from 'react';
import ILoader from './ILoader';
import * as style from './LoaderStyle.module.scss'

const Loader = (props: ILoader) => (
  <div
    className={[
      style.posRel,
      style.loaderContainer,
      props.moreSpace ? style.loaderSpace : '',
      props.fullWidth ? style.loaderFullWidth : '',
      props.small ? style.loaderSmall : '',
    ].join(' ')}
  >
    <div className={style.loader}>
      ...
    </div>
  </div>
);

export default Loader;
